<template>
<div class="row">
  <div class="columns">
    <div class="members-toggle">
      <div class="members-toggle--wrap">
        <a class="members-toggle--btn active guild-members" href="#" data-id="members" v-on:click="toggle($event)">Guild Members </a>
        <a class="members-toggle--btn business-affiliates" href="#" data-id="affiliates" v-on:click="toggle($event) "> Business Affiliates </a>
        <span/>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
mounted: function(){
    let index = 0;
    let btns = document.querySelectorAll('.members-toggle--btn');
    let highlight = document.querySelector('.members-toggle span');
    let btn = btns[index];
    let width = btn.offsetWidth;
    highlight.style.width = `${width}px`;
    highlight.style.opacity = 1;
    setTimeout(function(){
      highlight.classList.add('in-view');
    }, 350);

    this.setSelected(index);
  },

  methods: {
    toggle: function(event){
      this.$parent.switchJSON(event);
      let target = event.target;
      // Exit if .active
      if(target.classList.contains('active')){
        return false;
      }
      // Add/Remove .active class
      let selected = target.dataset.id;
      let btns = document.querySelectorAll('.members-toggle--btn');
      [...btns].forEach((btn, index) => {
        let id = btn.dataset.id;
        if(selected === id){ // Selected element
          this.setSelected(index);
        } else {
          btn.classList.remove('active');
        }
      });
    },

    // Set select state of toggles
    setSelected: function(index){
      let parent = document.querySelector('.members-toggle');
      let btns = document.querySelectorAll('.members-toggle--btn');
      let highlight = document.querySelector('.members-toggle span');

      let btn = btns[index];
      let width = btn.offsetWidth;
      let left = btn.offsetLeft;

      setTimeout(function(){
        btn.classList.add('active');
      }, 125);

      highlight.style.width = `${width}px`;
      highlight.style.left = `${left}px`;
    }
  },
  computed: {

  }
}
</script>



// WEBPACK FOOTER //
// CMS/NationalGuild/src/js/vueComponents/MembersToggle.vue